export const MintStatus = {
  WAITING: 'WAITING',
  MINTING: 'MINTING',
  DONE: 'DONE',
};

export type MintStatusType = 'WAITING' | 'MINTING' | 'DONE';
